import { render, staticRenderFns } from "./xmgdFrom.vue?vue&type=template&id=716ed34a&scoped=true&"
import script from "./xmgdFrom.vue?vue&type=script&lang=js&"
export * from "./xmgdFrom.vue?vue&type=script&lang=js&"
import style0 from "./xmgdFrom.vue?vue&type=style&index=0&id=716ed34a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ed34a",
  null
  
)

export default component.exports